import React, { Component, Fragment } from 'react';
import Breadcrumb from '../../common/breadcrumb';
// import CKEditors from "react-ckeditor-component";
import CKEditor from "react-ckeditor-component";
import MyDropzone from '../../common/dropzone'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Redirect } from 'react-router-dom';

export class Digital_edit_pro extends Component {
    constructor(props) {
        super(props)

        this.updateContent = this.updateContent.bind(this);
        this.updateRequirement = this.updateRequirement.bind(this)
        this.onChange = this.onChange.bind(this)
        this.onChangereq = this.onChangereq.bind(this)

        this.state = {
            content: '',
            categories: [],
            subcategories: [],
            subcat: '',
            image: '',
            image1: '',
            image2: '',
            image3: '',
            product: [],
            requirements: '',
            dirname: '',
            offerFree:false,
            price:'',
            offerPrice:'',
        }
        this.uploadFileHandler = this.uploadFileHandler.bind(this)
        this.uploadFileHandler1 = this.uploadFileHandler1.bind(this)
        this.uploadFileHandler2 = this.uploadFileHandler2.bind(this)
        this.uploadFileHandler3 = this.uploadFileHandler3.bind(this)
        this.submitHandler = this.submitHandler.bind(this)
    }

    updateContent(newContent) {
        this.setState({
            content: newContent
        })
    }
    updateRequirement(newContent) {
        this.setState({
            requirements: newContent
        })
    }

    onChange(evt) {
        var newContent = evt.editor.getData();
        this.setState({
            content: newContent
        })
    }

    onChangereq(evt) {
        var newContent = evt.editor.getData();
        this.setState({
            requirements: newContent
        })
    }

    onBlur(evt) {
        console.log("onBlur event called with event info: ", evt);
    }

    afterPaste(evt) {
        console.log("afterPaste event called with event info: ", evt);
    }

    componentDidMount() {
 console.clear();
 if (!localStorage.getItem('userInfo')) {
     window.location.href = '/admin';
    }
    //  console.log("window.location.href");
    //  console.log(window.location.href);
        const thePath = window.location.href;
        const lastItem = thePath.substring(thePath.lastIndexOf('/') + 1)
        // console.log(thePath)
        fetch(`${process.env['REACT_APP_HOST']}/api/products/${lastItem}`)
            .then((response) => response.json())
            .then(result => {
                console.log(result)
                this.setState({ product: result });
                this.setState({ content: result.description })
                this.setState({ requirements: result.requirements })
                this.setState({ dirname: result.dirname })
                this.setState({ offerFree: result.offerFree })
                this.setState({ price: result.price })
                this.setState({ offerPrice: result.offerPrice })
                this.getSubcategories(result.category)
             });
        fetch(`${process.env['REACT_APP_HOST']}/api/categories`)
            .then((response) => response.json())
            .then(result => {
                console.log(result)
                this.setState({ categories: result.categoryList });
            });

        fetch(`${process.env['REACT_APP_HOST']}/api/subcategories`)
            .then((response) => response.json())
            .then(result => {
                console.log(result)
                this.setState({ subcategories: result.subcategories });
            });
    }

    changeText(event, editor) {
        console.log(editor.getData());
    }

    uploadFileHandler = async (e) => {
        const file = e.target.files[0]
        const formData = new FormData()
        formData.append('image', file)
        try {
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'test': this.state.dirname,
                    'filename': '0'

                },
            }
            const { data } = await axios.post(`${process.env['REACT_APP_HOST']}/api/upload`, formData, config)
            this.setState({ image: data })
        } catch (error) {
        }
    }

    uploadFileHandler1 = async (e) => {
        const file = e.target.files[0]
        const formData = new FormData()
        formData.append('image', file)
        try {
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'test': this.state.dirname,
                    'filename': '1'
                },
            }
            const { data } = await axios.post(`${process.env['REACT_APP_HOST']}/api/upload`, formData, config)
            this.setState({ image1: data })
        } catch (error) {
        }
    }

    uploadFileHandler2 = async (e) => {
        const file = e.target.files[0]
        const formData = new FormData()
        formData.append('image', file)
        try {
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'test': this.state.dirname,
                    'filename': '2'
                },
            }
            const { data } = await axios.post(`${process.env['REACT_APP_HOST']}/api/upload`, formData, config)
            this.setState({ image2: data })
        } catch (error) {
        }
    }

    uploadFileHandler3 = async (e) => {
        const file = e.target.files[0]
        const formData = new FormData()
        formData.append('image', file)
        try {
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'test': this.state.dirname,
                    'filename': '3'
                },
            }
            const { data } = await axios.post(`${process.env['REACT_APP_HOST']}/api/upload`, formData, config)
            this.setState({ image3: data })
        } catch (error) {
        }
    }

    submitHandler(e) {
        e.preventDefault();
        var mobilePlatform = 'no';
        var desktopPlatform = 'no';
        var vrPlatform = 'no';
        var threeSixtyPlatform = 'no';
        var webglPlatform = 'no';

        if (e.target.mobilePlatform.checked) {
            mobilePlatform = 'yes';
        }
        if (e.target.desktopPlatform.checked) {
            desktopPlatform = 'yes';
        }
        if (e.target.vrPlatform.checked) {
            vrPlatform = 'yes';
        }
        if (e.target.threeSixtyPlatform.checked) {
            threeSixtyPlatform = 'yes';
        }
        if (e.target.webglPlatform.checked) {
            webglPlatform = 'yes';
        }
        const thePath = window.location.href;
        const lastItem = thePath.substring(thePath.lastIndexOf('/') + 1)
        const url = `${process.env['REACT_APP_HOST']}/api/products/${lastItem}`;
        const params = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                name: e.target.name.value,
                price: e.target.price.value,
                category: e.target.category.value,
                subcategory: e.target.subcategory.value,
                status: this.state.product.status,
                description: this.state.content,
                image: this.state.image,
                image1: this.state.image1,
                image2: this.state.image2,
                image3: this.state.image3,
                requirements: this.state.requirements,
                offerPrice: e.target.offerPrice.value,
                offerFree: this.state.offerFree,
                learningOutcomes: e.target.learningOutcomes.value,
                duration: e.target.duration.value,
                modulesNo: e.target.modulesNo.value,
                dirname: this.state.dirname,
                mobilePlatform: mobilePlatform,
                desktopPlatform: desktopPlatform,
                vrPlatform: vrPlatform,
                threeSixtyPlatform: threeSixtyPlatform,
                webglPlatform: webglPlatform,
            }),
        };
        if(this.state.offerFree === false){
        if (Number(e.target.price.value) > Number(e.target.offerPrice.value)) {
            fetch(url, params)
                .then(response => response.json())
                .then(data => {
                    console.log(data)
                    // window.location.reload(); 
                    if (data.message) {
                        toast.error("Please fill all the required fields !")
                        setTimeout(() => {
                            //  window.location.reload(); 
                        }, 3000);
                    } else {
                        toast.success("Successfully Updated !")
                        setTimeout(() => {
                            this.props.history.push('/products/digital/digital-product-list');
                        }, 3000);
                    }
                    // 
                })
        } else {
            toast.error("Offer price should be less than actual price")
        }
    }else{
        fetch(url, params)
        .then(response => response.json())
        .then(data => {
            console.log(data)
            // window.location.reload(); 
            if (data.message) {
                toast.error("Please fill all the required fields !")
                setTimeout(() => {
                    //  window.location.reload(); 
                }, 3000);
            } else {
                toast.success("Successfully Updated !")
                setTimeout(() => {
                    this.props.history.push('/products/digital/digital-product-list');
                }, 3000);
            }
            // 
        }) 
    }
    }

    getSubcategories = (e) => {
        const catId = e;
        fetch(`${process.env['REACT_APP_HOST']}/api/subcategories/${catId}/subcat`)
            .then((response) => response.json())
            .then(result => {
                console.log(result)
                this.setState({ subcategories: result });
            });
    }

    offerFree=()=>{
        this.setState({ offerFree: !this.state.offerFree})
     }

    render() {
        // console.log(this.state.product)
        return (
            <Fragment>
                <Breadcrumb title="Edit Products" parent="Digital" />
                <ToastContainer />
                <div className="container-fluid">
                    <form method="post" onSubmit={this.submitHandler}>
                        <div className="row product-editting">
                            <div className="col-xl-6">
                                <div className="card">
                                    <div className="card-header">
                                        <h5>General</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="digital-edit needs-validation">
                                            <div className="form-group">
                                                <label className="col-form-label pt-0"><span>*</span> Title</label>
                                                <input className="form-control" defaultValue={this.state.product.name} name="name" id="validationCustom01" type="text" required="" ></input>
                                            </div>

                                            <div className="form-group">
                                            <div className="row"> 
                                            <div className="col-6">
                                                  <label className="col-form-label pt-0"><span>*</span> Price</label>
                                            </div>
                                            <div className="col-6 text-right">
                                                   <input type="checkbox" name="offerFree" onClick={this.offerFree} checked={this.state.offerFree}></input> Make it free
                                            </div>
                                            </div>

                                            { this.state.offerFree === false ?
                                                <input className="form-control" name="price" id="validationCustom02"  value={this.state.price} onChange={(e) => this.setState({ price:e.target.value })} type="number" required=""></input>
                                            : 
                                                <input className="form-control" name="price" value="0"  id="validationCustom02" type="number" disabled></input>
                                            }
                                            </div>

                                            <div className="form-group">
                                                <label className="col-form-label pt-0"><span>*</span> Offer Price</label>
                                                { this.state.offerFree === false ?
                                                      <input className="form-control" name="offerPrice" id="validationCustom02" value={this.state.offerPrice} onChange={(e) => this.setState({ offerPrice:e.target.value })} type="number" required=""></input>
                                                    : 
                                                      <input className="form-control" name="offerPrice" value="" id="validationCustom02" type="number" disabled></input>
                                                }
                                            </div>

                                            <div className="form-group">
                                                <label className="col-form-label"><span>*</span> Categories</label>
                                                <select className="custom-select" name="category" required="" onChange={(e) => this.getSubcategories(e.target.value)} >
                                                    <option value="">--Select--</option>
                                                    {this.state.categories.map(category => (
                                                        <option value={category.id} selected={this.state.product.category == category.id} >{category.name}</option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="form-group" id="subcategory" >
                                                <label className="col-form-label"><span>*</span> Subcategories</label>
                                                <select className="custom-select" name="subcategory" required="" onChange={(e) => this.setState({ subcat: e.target.value })} >
                                                    <option value="">--Select--</option>
                                                    {
                                                        this.state.subcategories.map(subcat => (
                                                            <option value={subcat._id} selected={this.state.product.subcategory == subcat._id}>{subcat.name}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>


                                            {/* <MyDropzone /> */}
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header">
                                        <h5>Add Requirements</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="digital-add needs-validation">
                                            <div className="form-group mb-0">
                                                <div className="description-sm">
                                                    <CKEditor
                                                        activeClass="p10"
                                                        content={this.state.requirements}
                                                        events={{
                                                            "blur": this.onBlur,
                                                            "afterPaste": this.afterPaste,
                                                            "change": this.onChangereq
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="card">
                                    <div className="card-header">
                                        <h5>Add Description</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="digital-add needs-validation">
                                            <div className="form-group mb-0">
                                                <div className="description-sm">
                                                    <CKEditor
                                                        activeClass="p10"
                                                        content={this.state.content}
                                                        events={{
                                                            "blur": this.onBlur,
                                                            "afterPaste": this.afterPaste,
                                                            "change": this.onChange
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-header">
                                        <h5>Product Info</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="digital-add needs-validation">
                                            {this.state.product.mobilePlatform ?
                                                <>
                                                    <div className="form-group">
                                                        {/* <label className="col-form-label">Mobile Platform </label> */}
                                                        <input type="checkbox" defaultChecked={this.state.product.mobilePlatform == "yes"} name="mobilePlatform" ></input> Mobile Platform
                                            </div>
                                                    <div className="form-group">
                                                        <input type="checkbox" defaultChecked={this.state.product.desktopPlatform == "yes"} name="desktopPlatform"  ></input> Desktop Platform
                                            </div>
                                                    <div className="form-group">
                                                        {/* <label className="col-form-label">VR Platform </label> */}
                                                        <input type="checkbox" defaultChecked={this.state.product.vrPlatform == "yes"} name="vrPlatform"></input> VR Platform
                                            </div>
                                                    <div className="form-group">
                                                        <input type="checkbox" defaultChecked={this.state.product.threeSixtyPlatform == "yes"} name="threeSixtyPlatform" ></input> 360 Platform
                                            </div>
                                                    <div className="form-group">
                                                        <input type="checkbox" defaultChecked={this.state.product.webglPlatform == "yes"} name="webglPlatform" ></input> WebGL Platform
                                            </div>
                                                </>

                                                : null}


                                            <div className="form-group">
                                                <label className="col-form-label"><span>*</span> Learning Outcomes</label>
                                                <textarea className="form-control" defaultValue={this.state.product.learningOutcomes} name="learningOutcomes" id="validationCustom02" type="text" required="" />
                                            </div>
                                            <div className="form-group">
                                                <label className="col-form-label"><span>*</span> Duration</label>
                                                <input className="form-control" defaultValue={this.state.product.duration} name="duration" id="validationCustom02" type="text" required="" />
                                            </div>
                                            <div className="form-group">
                                                <label className="col-form-label"><span>*</span> No of Modules / Milestone</label>
                                                <input className="form-control" defaultValue={this.state.product.modulesNo} name="modulesNo" id="validationCustom02" type="number" required="" />
                                            </div>

                                            <div className="form-group mb-0">
                                                <div className="product-buttons text-center">
                                                    {/* <button type="button" className="btn btn-primary">Add</button> */}
                                                    <input type="submit" className="btn btn-primary" name="save" value="Update" />
                                                    {/* <button type="button" className="btn btn-light">Discard</button> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </Fragment>
        )
    }
}

export default Digital_edit_pro
